<template>
  <v-container>
    <v-row>
      <v-col>
        <TablePicker
          title="Data Table"
          v-model="value.table"
          :required="true"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <FieldValuePickerBase
          title="Row ID Value"
          v-model="value.idValue"
          :source="value.idSource"
          :table="table"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <ColumnValueListEditor
          title="Updating Values"
          :table="value.table"
          v-model="value.values"
          :field-table="table"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablePicker from "../shared/TablePicker.vue";
import ColumnValueListEditor from "../shared/ColumnValueListEditor.vue";
import FieldValuePickerBase from "../shared/FieldValuePickerBase.vue";

export default {
  name: "UpdateDataDesigner",

  components: {
    TablePicker,
    ColumnValueListEditor,
    FieldValuePickerBase,
  },

  props: ["value", "containers", "table", "component"],
};
</script>
